<div class="modal-body">
  <h2 class="modal-title">Hantera ritunderlag</h2>

  <rask-list [data]="ritunderlag$ | async">
    <rask-list-column header="Namn" field="filnamn"></rask-list-column>
    <rask-list-column header="Datum" field="skapadTidpunkt"></rask-list-column>
    @if (canDelete()) {
      <rask-list-column field="" width="90px">
        <ng-template let-row="row">
          <rask-icon-button negative (click)="deleteDokument(row)"
          icon="far fa-trash-alt fa-lg"></rask-icon-button>
        </ng-template>
      </rask-list-column>
    }
  </rask-list>

  <div class="d-flex">
    @if (fileUploadError.length > 0) {
      <div class="alert alert-danger pa-3" role="alert">
        {{fileUploadError}}
      </div>
    }
  </div>

  <div class="d-flex form-spacing pb-3">
    <div class="col-9 ">
      <rask-file-upload
        accept=".zip"
        (fileChange)="onFileSelected(upload.files)"
        [disabled]="!hasUploadFilePermission || !(kontraktId > 0)"
        #upload
        class="file-input-box">
        <span preview>
          {{upload.files | joinValues: "name": ", " }}
        </span>
        <span placeholder>
          @if(kontraktId > 0){
            Välj eller drag och släpp fil (zip)
          }
          @else {
          För att kunna lägga till filer måste kontraktet först sparas
        }
      </span>
    </rask-file-upload>
  </div>
  <div class="col-2">
    <button type="button" class="btn btn-primary" [disabled]="uploadButtonInactive || readonly"
      (click)="uploadDocument()"
    translate="VIRKESKOP_ANBUD_KONTRAKT_TILLAGDA_FILER_LADDA_UP"></button>
    <rask-info>
      Uppladdad fil skall vara av typen .zip och innehålla två filer, en av varje: <br /><br />
      1) Bild av typ jpg. <br />
      2) .JGW fil med koordinater för bilden
    </rask-info>

  </div>
</div>

<div class="d-flex justify-content-end">
  <rask-button color="secondary" (click)="close()">Stäng</rask-button>
</div>
</div>